import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import SectionHeader from './SectionHeader';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string | React.ReactNode;
  icon: SvgIconComponent;
  colorClass?: string;
  confirmLabel?: string;
  cancelLabel?: string | null;
}

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  icon,
  colorClass = 'bg-[#ff7500]',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
}: ConfirmationModalProps) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, p: 1.5 } }}
    >
      <DialogContent sx={{ pb: 1 }}>
        <div className='flex flex-col'>
          <SectionHeader title={title} icon={icon} colorClass={colorClass} />
          <div className='text-gray-600 text-[16px] leading-relaxed font-medium px-1'>
            {description}
          </div>
        </div>
      </DialogContent>
      <DialogActions className='px-6 pb-6 gap-3'>
        {cancelLabel && (
          <GlobalButton action={onClose} variant={GlobalButtonVariant.secondaryButton}>
            {cancelLabel}
          </GlobalButton>
        )}
        <GlobalButton action={onConfirm} variant={GlobalButtonVariant.primaryButton}>
          {confirmLabel}
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
